import herobg from '../../../assets/img/hero.jpg'
import { ReactComponent as Badge5 } from '../../../assets/img/hero_icons/invoice.svg'
import { ReactComponent as Badge1 } from '../../../assets/img/hero_icons/laptop.svg'
import { ReactComponent as Badge6 } from '../../../assets/img/hero_icons/log-file.svg'
import { ReactComponent as Badge7 } from '../../../assets/img/hero_icons/note.svg'
import { ReactComponent as Badge2 } from '../../../assets/img/hero_icons/store.svg'
import { ReactComponent as Badge3 } from '../../../assets/img/hero_icons/warehouse.svg'
import { ReactComponent as Badge4 } from '../../../assets/img/hero_icons/woman.svg'
import Badge from '../../molecules/Badge'
import { AccentButton, BorderButton } from '../../molecules/Button'

export default function HeroSection() {
    return (
        <section className="w-full h-92.5 sm:h-full flex md:flex-col">

            <section className="w-1/2 md:w-full h-full md:h-3/5 sm:h-full bg-primary flex flex-col justify-center items-center py-0 px-11">

                <span className="font-bold text-white text-5xl sm:text-4xl text-left sm:text-center leading-16">
                    Manage Your Retail <br className='sm:hidden' /> With The Best Scrutiny And Accountability Tool
                </span>

                <span className="text-secondary2 text-left self-start my-8 mx-0 sm:text-center">
                    Finally. A shop management solution that scales with your business. 
                </span>

                <div className="flex flex-row content-start w-full sm:justify-center sm:flex-col">

                    <div
                        className="mr-4 sm:mr-0 sm:mb-4"
                    >
                        <AccentButton>
                            Book a free demo
                        </AccentButton>
                    </div>

                    <div>
                        <BorderButton>
                            Our Pricing
                        </BorderButton>
                    </div>

                </div>

                <div className="flex flex-row flex-wrap self-start justify-center relative bottom-neg-1/5 md:bottom-neg-3/20 sm:bottom-neg-40 left-0">

                    <div className="mr-4">
                        <Badge>
                            <Badge1 />
                        </Badge>
                    </div>
                    <div className="mr-4">
                        <Badge>
                            <Badge2 />
                        </Badge>
                    </div>
                    <div className="mr-4">
                        <Badge>
                            <Badge3 />
                        </Badge>
                    </div>
                    <div className="mr-4">
                        <Badge>
                            <Badge4 />
                        </Badge>
                    </div>
                    <div className="mr-4">
                        <Badge>
                            <Badge5 />
                        </Badge>
                    </div>
                    <div className="mr-4">
                        <Badge>
                            <Badge6 />
                        </Badge>
                    </div>
                    <div className="mr-0">
                        <Badge>
                            <Badge7 />
                        </Badge>
                    </div>

                </div>


            </section>

            <figure 
                className="w-1/2 md:w-full h-full md:h-2/5 bg-no-repeat bg-center bg-cover sm:hidden"
                style={{
                    backgroundImage: `url(${herobg})`
                }}
            />

        </section>
    )
}
